import { PackageType } from '@amzn/awsdev-docs-virtual-smiley-conference-typescript-client';

/**
 * Package types eligible for post-conference auto-merge (i.e. the ones for which a Destination
 * branch is meaningful and accepted).
 *
 * This MUST stay in sync with the backend source of truth,
 * CommonConstants.AUTO_MERGE_ELIGIBLE_PACKAGE_TYPES (AWSDevDocsVirtualSmileyConferenceToolCommon),
 * which both the submission-time API validation and the post-conference merge worker use. The UI
 * uses it to disable/clear the Destination branch field for unsupported types; the API is the
 * authoritative gate that rejects a destination branch on any other type.
 */
export const AUTO_MERGE_ELIGIBLE_PACKAGE_TYPES: ReadonlySet<PackageType> =
  new Set([
    PackageType.GUIDE_OR_HELP_PANEL,
    PackageType.SERVICE_LANDING_PAGE,
    PackageType.SERVICE_SHARED_CONTENT,
    PackageType.CHECKLIST,
  ]);

/**
 * Whether a package type supports the Destination branch (post-conference auto-merge). An empty /
 * unselected type is not eligible.
 */
export const isAutoMergeEligible = (
  packageType: PackageType | '' | undefined
): boolean =>
  !!packageType &&
  AUTO_MERGE_ELIGIBLE_PACKAGE_TYPES.has(packageType as PackageType);
